import { render, staticRenderFns } from "./MyIm.vue?vue&type=template&id=30bfeb9a&scoped=true&"
import script from "./MyIm.vue?vue&type=script&lang=js&"
export * from "./MyIm.vue?vue&type=script&lang=js&"
import style0 from "./MyIm.vue?vue&type=style&index=0&id=30bfeb9a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bfeb9a",
  null
  
)

export default component.exports